// Runtime config — reads from window.__ENV__ (injected at container startup),
// falls back to process.env (webpack build-time) for local dev.
const env = window.__ENV__ || {};

export const config = {
  apiUrl: env.VUE_APP_API_URL || process.env.VUE_APP_API_URL || '',
  keycloakUrl: env.VUE_APP_KEYCLOAK_URL || process.env.VUE_APP_KEYCLOAK_URL || '',
  keycloakRealm: env.VUE_APP_KEYCLOAK_REALM || process.env.VUE_APP_KEYCLOAK_REALM || 'hypcheck',
  keycloakClientId: env.VUE_APP_KEYCLOAK_CLIENT_ID || process.env.VUE_APP_KEYCLOAK_CLIENT_ID || 'hypcheck-frontend',
};
